import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWidthFull = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 47.54 28.485",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Full_bredde",
		"data-name": "Full bredde",
		transform: "translate(-875.51 -2367.25)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_175",
				"data-name": "Group 175",
				transform: "translate(877.317 2377.016)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_186",
						"data-name": "Rectangle 186",
						width: 42.408,
						height: 1.582,
						transform: "translate(1.662 3.693)"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_173",
						"data-name": "Group 173",
						children: [/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_187",
							"data-name": "Rectangle 187",
							width: 1.582,
							height: 6.33,
							transform: "translate(4.476) rotate(45)"
						}), /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_188",
							"data-name": "Rectangle 188",
							width: 1.582,
							height: 6.33,
							transform: "translate(5.595 7.833) rotate(135)"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_174",
						"data-name": "Group 174",
						transform: "translate(40.138 0)",
						children: [/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_189",
							"data-name": "Rectangle 189",
							width: 1.582,
							height: 6.33,
							transform: "translate(1.119 8.952) rotate(-135)"
						}), /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_190",
							"data-name": "Rectangle 190",
							width: 1.582,
							height: 6.33,
							transform: "translate(0 1.119) rotate(-45)"
						})]
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2770",
				"data-name": "Path 2770",
				d: "M-20,0H27.54V1.582H-20Z",
				transform: "translate(895.51 2367.25)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2771",
				"data-name": "Path 2771",
				d: "M-20,0H27.54V1.582H-20Z",
				transform: "translate(895.51 2394.152)"
			})
		]
	})
});
export default SvgWidthFull;
